module.exports = __webpack_public_path__ + "static/media/Finnovex-Middle-East-2024.1db88f46.png";